/**
 * Created by agung<agung.julisman@yahoo.com> on 05/10/15.
 * Improved by Adhitama Fikri <adhitamafikri@gmail.com> on 16/12/19 to use APIOrderSDK for carts
 */
'use strict'
app.controller('itemCatalogCtrl', [
  'Server',
  'anchorSmoothScroll',
  'Path',
  '$scope',
  'growl',
  '$timeout',
  '$log',
  '$sce',
  '$document',
  'ItemQuantity',
  'FileUploader',
  '$translate',
  '$window',
  'encodeService',
  'APIOrderSDK',
  'APIOrderSDKV2',
  'permissionService',
  'googleAnalytics4',
  function(
    Server,
    anchorSmoothScroll,
    Path,
    $scope,
    growl,
    $timeout,
    $log,
    $sce,
    $document,
    ItemQuantity,
    FileUploader,
    $translate,
    $window,
    encodeService,
    APIOrderSDK,
    APIOrderSDKV2,
    permissionService,
    googleAnalytics4
  ) {
    var self = this
    self.userid = userid
    self.quotation = {}
    self.cart = {}
    self.buyerMessage = {}
    self.is_login = is_login
    self.crsf_token = crsf_token
    $scope.home.pageClass = 'product-catalog'

    $scope.luggages = []
    $scope.isLoading = false
    $scope.purchaseError = false
    $scope.purchaseErrorMsg = ''

    // ** Added by Adhitama Fikri
    // * Revamp Product Catalogue
    // **************************

    self.orderby_model = ''

    self.description_is_expanded = false

    // product name character limit
    self.product_max_char = 45
    self.product_max_char_resp = 23

    // stuffs for product pagination
    self.product_current_page = 1
    self.product_per_page = 5

    // stuffs for review pagination
    self.review_current_page = 1
    self.review_max_char = 250

    // stuffs for rating star
    self.rate = 3
    self.max_rating = 5
    self.isReadonly = true

    // stuffs for sorting product
    self.product_orderby = [
      $translate.instant('PRODUCT_CATALOG.lowest_price'),
      $translate.instant('PRODUCT_CATALOG.highest_price'),
    ]
    self.product_orderby_selected = 'retail_price' // sort by price ascendingly by default

    // stuffs for sorting reviews
    self.review_orderby = [
      $translate.instant('PRODUCT_CATALOG.highest_rating'),
      $translate.instant('PRODUCT_CATALOG.lowest_rating'),
      $translate.instant('PRODUCT_CATALOG.latest'),
    ]
    self.review_orderby_selected = '-date' // sort by latest review by default

    self.directToVendorList = function() {
      anchorSmoothScroll.scrollTo('availableVendorList')
    }

    self.available_stock = 10000
    self.cleanQuantity = function() {
      for (var i = 0; i < self.result.vendor.length; i++) {
        var currType = self.result.vendor[i].inventory_type
        var currMin = self.result.vendor[i].minimum_order
        self.available_stock =
          currType === 'infinite'
            ? self.available_stock
            : self.result.vendor[i].available_stock
        var currMax = self.available_stock

        if (self.result.vendor[i].quantity < currMin) {
          self.result.vendor[i].quantity = currMin
        } else if (self.result.vendor[i].quantity > currMax) {
          self.result.vendor[i].quantity = currMax
        } else if (self.result.vendor[i].vendor_status === 'W') {
          self.result.vendor[i].quantity = currMin
          self.available_stock = currMin
        }
      }
    }

    // popover message
    self.popover_info =
      'Kisaran harga yang tertera berdasarkan harga yang ada di dalam katalog'

    // for rfq-form quantity counter
    self.rfq_quantity = 1
    self.cleanRfqQuantity = function() {
      if (
        typeof self.rfq_quantity == undefined ||
        self.rfq_quantity < 1
      ) {
        self.rfq_quantity = 1
      }
    }

    // Stuffs for RFQ Form
    self.units = [
      'Unit',
      'Meter',
      'Liter',
      'Box',
      'Roll',
      'Lusin',
      'Set',
    ]

    // read more function
    self.readMore = function(string, start) {
      self.description_is_expanded = true
      self.substring_desc = string.substring(start, string.length)
    }

    // self.reviews = [
    //     {
    //         'photo': '../asset/img/slide-dummy-2.jpg',
    //         'reviewer': 'Xavier Wulf',
    //         'date': '24 Maret 2018 14.30 WIB',
    //         'rating': 5,
    //         'content': 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo eos, beatae deleniti esse earum enim sit! Nihil sit reprehenderit aliquid! Cupiditate recusandae tenetur consequatur minus. '
    //     },
    //     {
    //         'photo': '../asset/img/slide-dummy-2.jpg',
    //         'reviewer': 'Adib Lukito',
    //         'date': '5 April 2018 14.30 WIB',
    //         'rating': 3,
    //         'content': 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo eos, beatae deleniti esse earum enim sit! Nihil sit reprehenderit aliquid! Cupiditate recusandae tenetur consequatur minus. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo eos, beatae deleniti esse earum enim sit! Nihil sit reprehenderit aliquid! Cupiditate recusandae tenetur consequatur minus. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo eos, beatae deleniti esse earum enim sit! Nihil sit reprehenderit aliquid! Cupiditate recusandae tenetur consequatur minus.'
    //     },
    //     {
    //         'photo': '../asset/img/slide-dummy-2.jpg',
    //         'reviewer': 'Zaytoven',
    //         'date': '17 Februari 2018 14.30 WIB',
    //         'rating': 2,
    //         'content': 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo eos, beatae deleniti esse earum enim sit! Nihil sit reprehenderit aliquid! Cupiditate recusandae tenetur consequatur minus. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo eos, beatae deleniti esse earum enim sit! Nihil sit reprehenderit aliquid! Cupiditate recusandae tenetur consequatur minus. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo eos, beatae deleniti esse earum enim sit! Nihil sit reprehenderit aliquid! Cupiditate recusandae tenetur consequatur minus. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illo eos, beatae deleniti esse earum enim sit! Nihil sit reprehenderit aliquid! Cupiditate recusandae tenetur consequatur minus.!!'
    //     },
    // ];

    // self.total_reviews = self.reviews.length;

    self.hoveringOver = function(value) {
      self.overStar = value
      self.percent = 100 * (value / self.max_rating)
    }

    // function to expand or shrink the review
    self.readMoreReview = function(review) {
      var len = 0
      review.is_expanded = true
      len = review.content.length
      review.substring_review = review.content.substring(
        self.review_max_char,
        len,
      )
    }

    self.setProductOrder = function(string) {
      var temp = $translate.instant(string)
      if (temp === 'Harga Tertinggi' || temp === 'Highest Price')
        self.product_orderby_selected = 'retail_price'
      else if (temp === 'Harga Terendah' || temp === 'Lowest Price')
        self.product_orderby_selected = '-retail_price'
    }

    self.setReviewOrder = function(string) {
      var temp = $translate.instant(string)
      // console.log('review will be sorted by: ' + temp);
      if (temp === 'Rating Tertinggi' || temp === 'Highest Rating')
        self.review_orderby_selected = '-rating'
      else if (temp === 'Rating Terendah' || temp === 'Lowest Rating')
        self.review_orderby_selected = 'rating'
      else if (temp === 'Terbaru' || temp === 'Latest')
        self.review_orderby_selected = '-date'
    }

    // dummy specification
    // self.completeSpec = {
    //     'Body' : {
    //         'Dimension': '129mm x 80mm',
    //         'Build': 'All Metal',
    //         'Weight': '180grams',
    //         'Color': 'Rose Gold, Jet Black, Pearl White, Red',
    //     },
    //     'Processor' : {
    //         'SOC': 'Snapdragon 625',
    //         'Clock Speed': '1,4 GHz',
    //         'Cores': 8,
    //         'GPU': 'Adreno 506',
    //         'GPU Speed': '450 MHz',
    //     },
    //     'Camera' : {
    //         'Main Camera': '16MP',
    //         'Front Camera': '8MP',
    //         'Lens': 'Leica',
    //         'Aperture': '1/2.3 inches',
    //     }
    // };

    // scroll to RFQ Form
    self.goToRFQForm = function() {
      anchorSmoothScroll.scrollTo('rfq_form')
    }

    // scroll to Product Specification
    self.goToSpecification = function() {
      anchorSmoothScroll.scrollTo('product_specification')
    }

    /**
     * Show modal cart on click buy now
     * @param {String} itemID
     * @param {String} qty
     */
    $scope.modalCart = function(itemID, quantity) {
      if (!permissionService.hasPermission('website.cart_access')) return;
      var data = {
        product_quantity: parseInt(quantity, 10),
        item_id: parseInt(itemID, 10),
      }

      if (!is_login) {
        window.localStorage.setItem('datacart', JSON.stringify(data))
        return (window.location.href = '/login?source=buy-catalog')
      }

      angular.element('#modalcart').modal()

      $scope.isLoading = true
      $scope.purchaseError = false
      $scope.purchaseErrorMsg = ''
      APIOrderSDKV2.addToCart(data.item_id, data.product_quantity)
        .then(function(response) {
          const atc_validation_result =
            response.data.result.atc_validation_result
          if (atc_validation_result.status === 'success') {
            const utmMedium = Path.getQueryUrl('utm_medium')
            googleAnalytics4.trackAddToCart(atc_validation_result.result, utmMedium)
            dataLayer.push({
              _products: atc_validation_result.result.analytics,
              event: 'addedToCart',
            })
            const cartDetail = response.data.result.detail
            const addedProductDetail = cartDetail.filter(function(el) {
              return el.details[0].id_item === atc_validation_result.result.analytics.productID
            })
            if (addedProductDetail &&
              addedProductDetail[0].details[0].stock_type === 'finite') {
              dataLayer.push({
                etrkC: 'Buyer Action',
                etrkA: 'Buyer Action - Add To Cart Product with Limited Stock',
                etrkL: 'Add to Cart - Product with Limited Stock',
                event: 'gaBehaviorEventCapture'
              })
            }
            APIOrderSDKV2.getCartItems()
              .then(function(getCartResponse) {
                const ATCGetCart = getCartResponse.data.result.atc_validation_result
                if (ATCGetCart.status === "success") {
                  $scope.isLoading = false
                  $scope.luggages = getCartResponse.data.result.detail
                  $scope.home.getCart()
                  // $scope.$apply()
                }
              })
              .catch(function(getCartError) {
                growl.error(String(getCartError))
              })
          } else {
            $scope.isLoading = false
            $scope.purchaseError = true
            $scope.purchaseErrorMsg = atc_validation_result.message
            $scope.$apply()
          }
        })
        .catch(function(err) {
          $scope.isLoading = false
          growl.error(String(err))
        })
    }

    if (is_login) {
      permissionService.checkPermissionList()
    }
    
    // for opening contact seller modal
    self.openContactSellerModal = function(item) {
      if (!permissionService.hasPermission('website.chat_seller')) return;
      $scope.home.isLoading = true
      if (!self.is_login) {
        localStorage.setItem('lastpage', window.location.href)
        window.location.href = 'login'
      } else {
        return Server.getDataFromServer(
          '/microsite/profile-chat/' + item.vendor_id,
        ).then(function(response) {
          var item_url =
            base_path +
            '/v/' +
            item.vendor_alias +
            '/product/' +
            self.result.item_detail.result.alias
          var item_detail = {
            "itemImg": self.result.item_detail.result.default_image,
            "itemName": item.item_name,
            "itemAlias": self.result.item_detail.result.alias,
            "itemPrice": item.retail_price,
            "vendorId": item.vendor_id.toString(),
            "vendorAlias": item.vendor_alias
          }
          localStorage.setItem('chatItemUrl', item_url)
          localStorage.setItem('itemId', item.item_id);
          localStorage.setItem('itemDetails', JSON.stringify(item_detail))
          var redirect = 'customer/chat/buyer?vendor_id=' + item.vendor_id
          window.location = redirect
        })
      }
    }
    // ******************

    //REDIRECT TO MESSAGE PAGE IF LOGIN
    self.contactSeller = function(vendor_id) {
      var message_path =
        base_path + '/message#/pm/compose/' + vendor_id
      if (is_login) {
        window.location = message_path
      } else {
        localStorage.setItem('lastpage', message_path)
        window.location = 'login'
      }
    }

    self.modalAskForQuotation = function(
      item_inital,
      microsite_url,
      qty,
    ) {
      //if($scope.home.is_login){
      /*send ga for quotation*/
      //ga('send', 'event', 'Quotation', 'click', 'add to quotation');
      $scope.isLoading = true
      self.quotation.issave = false
      self.quotation.listquotation = []
      angular.element('#modalquotation').modal()
      Server.posDataToServer('/quotation/add-quotation-item', {
        quantity: qty,
        item: item_inital,
        microsite_url: microsite_url,
      }).then(function(response) {
        if (response.status === 'success') {
          Server.getDataFromServer('/quotation/user-quotation').then(
            function(responses) {
              self.quotation.listquotation = responses.result
              $scope.home.getQuotationActive()
            },
          )
          $scope.isLoading = false
        }
      })
      //
      //}else{
      //    /*set lastpage url*/
      //    localStorage.setItem('lastpage',window.location.href);
      //    $scope.home.goto('login');
      //}
    }

    self.settoMax = function(idnyx) {
      if (self.amount[idnyx] > self.max[idnyx]) {
        self.amount[idnyx] = self.max[idnyx]
      }
    }

    // Check whether paramToCheck is not a null or zero
    self.isNotNullOrZero = function(paramToCheck) {
      var aNumber = parseFloat(paramToCheck)
      return !isNaN(aNumber) && aNumber != 0
    }

    self.settoMin = function(idnyx) {
      if (
        self.amount[idnyx] < self.min[idnyx] ||
        self.amount[idnyx] == null
      ) {
        self.amount[idnyx] = parseInt(self.min[idnyx])
      }
    }

    self.filter = {
      sort: 'cheap',
    }

    //redesign v5
    self.result = result
    self.itemPicture = self.result.item_detail.result.images
      ? self.result.item_detail.result.images[0]
      : 'noImage'
    self.varianceDefault =
      self.result.item_detail.result.variances.default
    self.base_path = base_path
    self.url =
      '/items/vendor-item-catalog-filter?alias=' +
      self.result.item_detail.result.alias
    self.params = ''
    self.productAccuracies =
      self.result.item_detail.result.reviews.accuracy_summary
    self.productQuality =
      self.result.item_detail.result.reviews.quality_summary
    self.productName = self.result.item_detail.result.name
      .replace(/&amp;/i, '&')
      .replace(/&quot;/i, '"')
    $scope.$parent.pageName = self.productName // For dynamic title in breadcrumb
    //self.decodeDescription = $sce.trustAsHtml(self.result.item_detail.result.description);
    self.getVendor = function(model, val) {
      $scope.$parent.home.isLoading = true
      self.params = ''
      self.spec = ''
      if (model && val)
        self.spec = '&filters[specs][' + model + '][]=' + val

      _.each(self.filter, function(val, key) {
        self.params += '&' + key + '=' + val
      })

      Server.getDataFromServer(
        self.url + self.spec + self.params,
      ).then(function(responses) {
        if (responses.status === 'success') {
          self.result.item_detail.result.variances =
            responses.result.default_variances
          self.varianceDefault = responses.result.variances.default
          self.result.vendor = responses.result.vendors
          self.productName = self.result.vendor[0].item_name
          $scope.$parent.pageName = self.productName
        } else {
          growl.error('failed get data variance')
        }
        $scope.$parent.home.isLoading = false
      })
    }

    /*reset the filter*/
    self.resetSearch = function() {
      window.location = window.location.href.split('?')[0]
    }

    $scope.tabFixedStyle = {
      background: 'white',
      width: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      'z-index': 3,
    }

    $scope.childTabFixedStyle = {
      width: 1200,
      margin: '0 auto',
      padding: '0 15px',
    }

    $document.on('scroll', function() {
      $scope.tabFixedStyle.top =
        $scope.$parent.home.stickyHeaderHeight - 1 // Minus 1 to hide the top border

      if (window.pageYOffset > 0) {
        $scope.fixedPos = true
      } else {
        $scope.fixedPos = false
      }
    })

    /*self.goToProduct = function(){
        anchorSmoothScroll.scrollTo('productAndSeller');
    };

    self.goToSpecification = function(){
        anchorSmoothScroll.scrollTo('productSpecification');
    };

    self.goToReview = function(){
        anchorSmoothScroll.scrollTo('productReview');
    };*/

    self.chatAll = function(
      vendorId,
      vendorName,
      item_id,
      productName,
      imageUrl,
      link,
      logo,
    ) {
      if (is_login) {
        $scope.home.dataChat.isItem = true
        $scope.home.dataChat.vendorId = vendorId
        $scope.home.dataChat.name = vendorName
        $scope.home.dataChat.item_id = item_id
        $scope.home.dataChat.productName = productName
        $scope.home.dataChat.productImage = imageUrl
        $scope.home.dataChat.productLink = link
        $scope.home.dataChat.logo = logo
        angular.element('#chatall').modal('show')
      } else {
        window.location = 'login'
      }
    }

    self.outOfStock = function(index) {
      if (self.result.vendor[index].inventory_type == 'finite') {
        if (
          self.result.vendor[index].available_stock == 0 ||
          self.result.vendor[index].retail_price == null ||
          self.result.vendor[index].retail_price == 0
        ) {
          self.hideAddToCart = false
          self.result.vendor[index].quantity = 0
          return true
        }
      } else {
        if (
          self.result.vendor[index].retail_price == null ||
          self.result.vendor[index].retail_price == 0
        ) {
          self.hideAddToCart = false
          self.result.vendor[index].quantity = 0
          return true
        }
      }
    }

    self.isMarketplace = function(index) {
      return (
        self.result.vendor[index].price_type.toLowerCase() ===
          'marketplace' ||
        self.result.vendor[index].is_stock_available === '0'
      )
    }

    /**
     * Determine price according to quantity
     * @param  {number} index    Index number of current item
     * @param  {string} quantity Input value in quantity field
     * @requires ItemQuantity
     */
    self.priceCalc = function(index, quantity) {
      var data = self.result.vendor[index]

      // Check quantity & adjust according to allowed value
      quantity = ItemQuantity.checkVal(data, quantity)
      self.result.vendor[index].quantity = quantity

      // Determine price based on quantity
      var prices = ItemQuantity.wholesaleCalc(quantity, data)
      self.result.vendor[index].price = prices.price
    }

    self.incQuantity = function(index) {
      self.result.vendor[index].quantity++
      self.priceCalc(index, self.result.vendor[index].quantity)
    }

    self.decQuantity = function(index) {
      self.result.vendor[index].quantity--
      self.priceCalc(index, self.result.vendor[index].quantity)
    }

    self.imageFiles = function() {
      var temp = Math.ceil(
        self.result.item_detail.result.images.length / 4,
      )
      var tempQty = []

      for (var i = 0; i < temp; i++) {
        tempQty.push(i)
      }
      self.imageQuantity = tempQty
    }

    self.changeThumb = function(idx) {
      self.thumb = 'thumb-' + idx
      self.itemPicture = self.result.item_detail.result.images[idx]
    }
  },
])

app.directive('itemCarousel', [
  'Config',
  function(Config) {
    return {
      restrict: 'A',
      templateUrl: Config.getUrl(
        'javascript/shared/ItemDetail/item-carousel.tpl.html',
      ),
      scope: false,
      bindToController: {
        index: '<',
        vendorType: '=',
        imageModel: '=',
        currentImage: '=',
      },
      controllerAs: 'ctrl',
      controller: [
        '$scope',
        function($scope) {
          var self = this || {}

          $scope.isGold = isGold
          $scope.widthDesktop = 280
          $scope.widthMobile = 340
          $scope.widthZoom = 600
          $scope.widthCurrent = $scope.widthDesktop

          $('#img-resp-carousel').attr(
            'data-zoom-image',
            $scope.ctrl.currentImage,
          )
          ;(self.initZoom = function() {
            setTimeout(function() {
              self.imgPreviewResponsive()

              angular.element('#item-preview').hover(function() {
                $(this).attr(
                  'data-zoom-image',
                  self.currentImage.replace(
                    /\/\d+\//g,
                    '/' + $scope.widthZoom + '/',
                  ),
                )
                angular.element(this).ezPlus()
              })
            }, 3000)
          })()

          self.imgPreviewResponsive = function() {
            if ($scope.home.screenType == 'mobile') {
              self.currentImage = self.currentImage.replace(
                /\/\d+\//g,
                '/' + $scope.widthMobile + '/',
              )
              $scope.widthCurrent = $scope.widthMobile
            } else {
              self.currentImage = self.currentImage.replace(
                /\/\d+\//g,
                '/' + $scope.widthDesktop + '/',
              )
              $scope.widthCurrent = $scope.widthDesktop
            }
          }

          // Detect screen type, desktop or mobile
          $scope.$watch(
            'home.screenType',
            function() {
              self.imgPreviewResponsive()
            },
            true,
          )

          self.doChangeImage = function(imageSrc) {
            self.currentImage = imageSrc
            angular
              .element('.zoomWindow')
              .css(
                'background-image',
                'url(' +
                  imageSrc.replace(
                    /\/\d+\//g,
                    '/' + $scope.widthZoom + '/',
                  ) +
                  ')',
              )

            self.imgPreviewResponsive()
          }
        },
      ],
    }
  },
])
